import {RichTextColorPickerComponentOptions} from "./rich-text-color-picker/rich-text-color-picker.component.js";

(function() {

    "use strict";

    const module = angular.module("components", []);

    module.component('richTextColorPicker', RichTextColorPickerComponentOptions);
})();